import { useState } from "react";
import UpdateEmailForm from "@/components/accounts/UpdateEmailForm";
import DeleteUserModalForm from "@/components/accounts/DeleteUserModalForm";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import useCurrentAccount from "@/components/context/useCurrentAccount";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { PageHeader } from "@/components/ui/page-header";

export default function ProfilePage() {
  const [updateEmailFormOpen, setUpdateEmailFormOpen] = useState(false);
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);

  const { account, isLoading } = useCurrentAccount({ requireLoggedIn: true });

  return (
    <DashboardLayout
      activePath="/dashboard/profile"
      title="Profile"
      breadcrumbs={[{ label: "Profile" }]}
    >
      <div className="mx-auto max-w-6xl px-4 py-8">
        <PageHeader title="Profile" description="Manage your personal account settings" />

        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Account Information</CardTitle>
              <CardDescription>Your personal account details</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div>
                  <p className="text-sm font-medium text-muted-foreground mb-1">Email Address</p>
                  {!isLoading && account ? (
                    <p className="text-lg">{account.email}</p>
                  ) : (
                    <div className="animate-pulse h-6 w-48 bg-muted rounded" />
                  )}
                </div>
                <Button variant="outline" onClick={() => setUpdateEmailFormOpen(true)}>
                  Change Email
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card className="border-destructive/50">
            <CardHeader>
              <CardTitle className="text-destructive">Danger Zone</CardTitle>
              <CardDescription>Irreversible and destructive actions</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-muted-foreground mb-4">
                    Permanently delete your user account, your workspace, and all associated data.
                    You will also be removed from any teams you belong to. This action cannot be
                    undone.
                  </p>
                  <Button variant="destructive" onClick={() => setDeleteUserModalOpen(true)}>
                    Delete User Account
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <UpdateEmailForm
          open={updateEmailFormOpen}
          setOpen={setUpdateEmailFormOpen}
          currentEmail={account?.email || ""}
        />
        <DeleteUserModalForm open={deleteUserModalOpen} setOpen={setDeleteUserModalOpen} />
      </div>
    </DashboardLayout>
  );
}
